import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Email } from '../../graphql/emails.datatypes';

interface EmailsData {
    emails: Email[],
}

export const GET_EMAILS_QUERY = gql`
    query getEmails{
        emails {
            id
            email
        }
    }
`;

export const getEmails = () => useQuery<EmailsData>(
    GET_EMAILS_QUERY,
    {
        variables: {
        }
    }
);

export default getEmails;
